function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.36 13.315v8.926c0 1.06.859 1.92 1.92 1.92h13.438c1.061 0 1.92-.86 1.92-1.92v-8.926M13.235 18.285l-5.31 5.309M24.074 23.594l-5.308-5.309",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.24 10.357l-2.029 1.366a1.92 1.92 0 000 3.186l5.64 3.794a3.85 3.85 0 004.298 0l5.64-3.794a1.92 1.92 0 000-3.187l-2.028-1.365",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.762 16.274V7.746a.96.96 0 00-.96-.96h-9.6a.96.96 0 00-.96.96v8.528M13.121 10.24h5.76M13.121 13.6h5.76",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEmailRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgEmailRead;